import { Tag } from 'antd';
import { DEMO_BUILD_STATUS_LABELS } from '../constants';

/** A demo build's status in plain words, and "Dismissed" once its creator dismissed it (SF-4746). */
export const StatusTag: React.FC<{ status: string; dismissed?: boolean }> = ({
  status,
  dismissed,
}) => {
  const s = DEMO_BUILD_STATUS_LABELS[status] ?? { label: status, color: 'default' };
  return (
    <>
      <Tag color={s.color}>{s.label}</Tag>
      {dismissed && <Tag>Dismissed</Tag>}
    </>
  );
};
